// import React from 'react'
// import './testimonialCard.css'
// import StarIcon from '@mui/icons-material/Star';
// import StarBorderIcon from '@mui/icons-material/StarBorder';
// import StarHalfIcon from '@mui/icons-material/StarHalf';
// const TestimonialCard = ({photo, name, description,rating}) => {
//   const renderStars = () => {
//     const stars = [];
//     const full = Math.floor(rating);
//     const hasHalf = rating - full >= 0.5;
//     const total = hasHalf ? full + 1 : full;

//     for (let i = 0; i < full; i++) {
//       stars.push(<StarIcon key={`full-${i}`} style={{color: 'hsl(45, 90%, 60%)'}} />);
//     }

//     if (hasHalf) {
//       stars.push(<StarHalfIcon key="half" style={{color: 'hsl(45, 90%, 60%)'}} />);
//     }

//     for (let i = total; i < 5; i++) {
//       stars.push(<StarBorderIcon  key={`empty-${i}`}  style={{color: 'hsl(45, 90%, 60%)'}} />);
//     }

//     return stars;
//   };
//   return (
//         <div className="testimonial-card">
//             <div className='img-box'>
//               <img src={photo}  alt={name} />
//             </div>
//             <h3>{name}</h3>
//             <p>{description}</p>
//             <div className='rating'>
//               {renderStars()}
//             </div>
//         </div>
//   )
// }

// export default TestimonialCard



import React from 'react';
import './testimonialCard.css';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import StarHalfIcon from '@mui/icons-material/StarHalf';

const TestimonialCard = ({ photo, name, description, rating, dataAos, dataAosDelay }) => {
  const renderStars = () => {
    const stars = [];
    const full = Math.floor(rating);
    const hasHalf = rating - full >= 0.5;
    const total = hasHalf ? full + 1 : full;

    for (let i = 0; i < full; i++) {
      stars.push(<StarIcon key={`full-${i}`} style={{ color: 'hsl(45, 90%, 60%)' }} />);
    }

    if (hasHalf) {
      stars.push(<StarHalfIcon key="half" style={{ color: 'hsl(45, 90%, 60%)' }} />);
    }

    for (let i = total; i < 5; i++) {
      stars.push(<StarBorderIcon key={`empty-${i}`} style={{ color: 'hsl(45, 90%, 60%)' }} />);
    }

    return stars;
  };

  return (
    <div
      className="testimonial-card"
  data-aos={dataAos || 'fade-up'}
  data-aos-delay={dataAosDelay?.toString() || '0'}
  data-aos-duration="800"
  data-aos-anchor-placement="top-bottom"
    >
      <div className='img-box'>
        <img src={photo} alt={`${name} - Niks Elite Cleaning customer review`} loading="lazy" />
      </div>
      <h3>{name}</h3>
      <p>{description}</p>
      <div className='rating'>
        {renderStars()}
      </div>
    </div>
  );
};

export default TestimonialCard;
